import Vue from 'vue'
import VueRouter from 'vue-router'
import { PAGE_META } from '@/constants/meta'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: () => import('@/views/Home/index.vue'), meta: PAGE_META.home },
  { path: '/ecosystem', name: 'Ecosystem', component: () => import('@/views/Ecosystem/index.vue'), meta: PAGE_META.ecosystem },
  { path: '/partners', name: 'Partners', component: () => import('@/views/Partners/index.vue'), meta: PAGE_META.partners },
  { path: '/about', name: 'About', component: () => import('@/views/About/index.vue'), meta: PAGE_META.about },
  { path: '/contact', name: 'Contact', component: () => import('@/views/Contact/index.vue'), meta: PAGE_META.contact },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) return { selector: to.hash, offset: { x: 0, y: 84 } }
    return { x: 0, y: 0 }
  }
})

router.afterEach((to) => {
  const meta = to.meta || PAGE_META.home
  document.title = meta.title
  let description = document.querySelector('meta[name="description"]')
  if (!description) {
    description = document.createElement('meta')
    description.setAttribute('name', 'description')
    document.head.appendChild(description)
  }
  description.setAttribute('content', meta.description)
})

export default router
